import {AfterViewInit, Component, OnInit, OnDestroy, Input} from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { SettingsService } from 'app/_services/settings.service';
import { UserModel } from 'app/_models/user-model';
 

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() collapsed: boolean = false;
  public color: string;
  public menuItems: object;
  public activeFontColor: string;
  public normalFontColor: string;
  public dividerBgColor: string;
  currentUser:UserModel;
  roles:string[];
  constructor(public settingsService: SettingsService) {
    this.menuItems = ROUTES;
    this.activeFontColor = 'rgba(0,0,0,.6)';
    this.normalFontColor = 'rgba(255,255,255,.8)';
    this.dividerBgColor = 'rgba(255, 255, 255, 0.5)';
  }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.roles = this.currentUser.roles;
    if (this.roles.length > 0) {
     this.roles = this.roles.map(function (x) {
        return x.toUpperCase();
      });
    }
       
    this.color = this.settingsService.getSidebarFilter();
    this.settingsService.sidebarFilterUpdate.subscribe((filter: string) => {
      this.color = filter;
      if (filter === '#fff') {
        this.activeFontColor = 'rgba(0,0,0,.6)';
      }else {
        this.activeFontColor = 'rgba(255,255,255,.8)';
      }
    });
    this.settingsService.sidebarColorUpdate.subscribe((color: string) => {
      if (color === '#fff') {
        this.normalFontColor = 'rgba(0,0,0,.6)';
        this.dividerBgColor = 'rgba(0,0,0,.1)';
      }else {
        this.normalFontColor = 'rgba(255,255,255,.8)';
        this.dividerBgColor = 'rgba(255, 255, 255, 0.5)';
      }
    });
    

  }
  ngOnDestroy() {
    this.settingsService.sidebarFilterUpdate.unsubscribe();
    this.settingsService.sidebarColorUpdate.unsubscribe();
  }

  ngAfterViewInit() {
  }

  checkValidation(event:any, path:string)
  {
    if(path == "#user-management"  && this.roles.includes("WAREHOUSEMANAGER") || this.roles.includes("USER"))
    {
      event.stopPropagation();
    }
  }
}
 